import { render, staticRenderFns } from "./CloseConversationModal.vue?vue&type=template&id=2bd4670c&scoped=true&"
import script from "./CloseConversationModal.vue?vue&type=script&lang=js&"
export * from "./CloseConversationModal.vue?vue&type=script&lang=js&"
import style0 from "./CloseConversationModal.vue?vue&type=style&index=0&id=2bd4670c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4670c",
  null
  
)

export default component.exports